
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const genesysblackg32: IProductData = {
  id: "neve-genesys-black-g32",
  name: "Genesys Black G32",
  description: "Legendary Neve Analog Console Sound, Full Digital Control, and Deep DAW Integration.",
  specialOrder: true,
  images: ["/img/neve_genesys_black_g32_front.jpg"],
  details: [{
    label: "Description",
    markdown: `
In the Golden Age of Analog, Neve — with the industry’s favorite mic preamps, EQ, flying-fader automation, and handcrafted-in-England build quality — was the console of choice for studios that could afford it. 
Then along came computer-based recording. It lacked the warm sonic allure of analog, but it was cheap and flexible. 
The world moved on, and professionals embraced digital audio workstation technology, even as it required tangles of cable clutter and errant interface incompatibilities. 
Neve engineers were sure they could provide a better solution. Enter Genesys Black. 

The design brief spec’d out a brand-new board that not only incorporates the best aspects of analog and digital, but does so at a price that makes owning a Neve possible for smaller studios — without compromise, sonic or otherwise.


The Neve Genesys Black features up to 32 mono inputs with 8 channel strips including the legendary 1073 mic preamps, 4-band EQ taken from the legendary 88RS. 
For larger mixing sessions, the Genesys Black’s 32 mono inputs can be used into the stereo mix with two insert per channel strip. 
Additional I/O include eight group buses with their own dedicated faders, two main outputs, four stereo returns, two cue mixes, and talkback functionality.
`
    }, {
      label: "Features",
      markdown: `
- 32-fader, 16-channel configuration
- 16-channel DAW monitoring; integral touchscreen DAW display
- 16 dedicated DAW control faders with corresponding stereo DAW metering on meter bridge
- 16 channels of Neve mic/line preamps
- Total Reset and Total Recall
- 2 stereo mix buses (Main Mix LR + 2T)
- 6 Aux buses (4 mono, 2 stereo)
- 2 stereo monitoring speaker sets
- Motorized Channel Faders with DAW Control
- Motorized 8T and Main Output faders with DAW control
- 16 channels of Neve 88R-style, 4-band EQ
- Optional integrated AD/DA converters (MADI/AES)
- 8 mono Groups, 2 Main outs
- 4 stereo effects returns with Width control
- Channel, DAW, 8T, 2T, and monitor metering
- 5.1 mixing and monitoring; 2 x 5.1 monitoring speaker sets
- 2 cue mixes
- Full talkback (and reverse talkback) capability
- Full console Instant Reset
- USB flash drive for Store, Load, and Reset functionality
- Hands-on DAW control for Pro Tools, Logic, Cubase, and more
- Expandable up to 48 channels
- Internal PSU
`
  }, {
    label: "Dimensions",
    markdown: `
• Weight: 240kg
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.ams-neve.com/consoles/mid-format/neve-genesys-black-console/" target="_blank">https://www.ams-neve.com/consoles/mid-format/neve-genesys-black-console/</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.MASTERING, HASHTAGS.LIVE_SOUND, HASHTAGS.MIXING],
    manufacturer: BRAND.NEVE,
  },
  videos: []
}